import { EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import { Configuration } from '@reliance/types/models/Configuration';
import { Facility } from '@reliance/types/models/Facility';
import { FORM_ERROR } from 'final-form';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Form } from 'react-final-form';
import { alertStore } from '../alert/alertStore';
import ErrorMessage from '../common/ErrorMessage';
import api from '../common/api';
import { useUser } from '../contexts/UserContext';
import AddEditForm from './AddEditForm';
import { validateGatedFeaturesForSubmit } from './FeatureCheckboxes';

type EditProps = {
  facility: Facility;
  onSave(): any;
};

const Edit: React.FC<EditProps> = (props) => {
  const user = useUser();

  const initialValues = {
    name: props.facility.name,
    address: props.facility.address,
    city: props.facility.city,
    state: props.facility.state,
    zip: props.facility.zip,
    county: props.facility.county,
    timezone: props.facility.timezone,
    ratePlanId: props.facility.ratePlan.id,
    serviceRatePlanId: props.facility.serviceRatePlans[0]?.ratePlan?.id,
    latitude: props.facility.latitude,
    longitude: props.facility.longitude,
    externalId: props.facility.externalId,
    inmateImportMode: props.facility.inmateImportMode,
    features: props.facility.features,
    communicationsEnabled: props.facility.communicationsEnabled,
    audioCallingEnabled: props.facility.audioCallingEnabled,
    videoCallingEnabled: props.facility.videoCallingEnabled,
    featureTexting: props.facility.featureTexting,
    textingLocalStatus: props.facility.textingLocalStatus == EnabledDisabled.ENABLED,
    featureCommissaryTransfer: props.facility.featureCommissaryTransfer,
    itdsMode: props.facility.itdsMode,
    facilityType: props.facility.facilityType,
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={async (formData) => {
        // This needs to be sent as enable/disabled rather than a boolean
        formData.textingLocalStatus = formData.textingLocalStatus ? EnabledDisabled.ENABLED : EnabledDisabled.DISABLED;
        const { data } = await api.get<Configuration[] | null>('/configuration', {
          params: { facilityId: props.facility.id },
        });
        const configurations = data == null ? [] : Array.isArray(data) ? data : [];
        const validationMessage = validateGatedFeaturesForSubmit(formData, configurations);
        if (validationMessage != null) {
          return { [FORM_ERROR]: validationMessage };
        }
        return api.put(`/facility/${props.facility.id}`, formData)
          .then(() => alertStore.success('Facility was successfully saved'))
          .then(() => localStorage.removeItem('cachedFacilities'))
          .then(props.onSave)
          .catch((err) => ({ [FORM_ERROR]: err }));
      }}
      render={(form) =>
        <form onSubmit={form.handleSubmit}>
          <Card>
            <Card.Body>
              <AddEditForm form={form} user={user} facility={props.facility} />
            </Card.Body>
            <Card.Footer>
              {form.hasValidationErrors && form.submitFailed &&
                <ErrorMessage message="Please fix the invalid fields before submitting" />
              }

              <Button
                variant="primary"
                disabled={form.submitting}
                type="submit">
                Save
              </Button>
            </Card.Footer>
          </Card>
        </form>
      } />
  );
};

export default Edit;
